<template>
  <div class="req-report-header-loader">
    <div class="req-report-header-loader-left loader">
      <v-skeleton-loader class="mb-2" type="heading" width="400" />
      <v-skeleton-loader type="text" width="150" />
    </div>
    <div class="req-report-header-loader-right">
      <div class="req-report-header-loader-summaries loader">
        <div class="summaries-left">
          <v-skeleton-loader class="mb-1" type="heading" width="50" />
          <v-skeleton-loader type="heading" width="50" />
        </div>
        <div class="summaries-right">
          <v-skeleton-loader class="mb-1" type="heading" width="100" />
          <v-skeleton-loader type="heading" width="50" />
        </div>
      </div>
      <div class="req-report-header-loader-comment loader">
        <v-skeleton-loader type="heading" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
:deep(.v-skeleton-loader__heading) {
  margin: 0px;
  height: 20px;
}

:deep(.v-skeleton-loader__text) {
  margin: 0px;
}

.loader {
  background: @white;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  padding: 24px;
}

.req-report-header-loader {
  height: 124px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  .req-report-header-loader-left {
    grid-column: span 2;
  }

  .req-report-header-loader-right {
    display: flex;

    .req-report-header-loader-summaries {
      display: grid;
      grid-template-columns: 50% 50%;

      .summaries-left {
        grid-column: 1;
      }

      .summaries-right {
        grid-column: 2;
      }
    }

    .req-report-header-loader-comment {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;

      :deep(.v-skeleton-loader__heading) {
        border-radius: 4px;
        width: 20px;
      }
    }
  }
}
</style>
